// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2LGvq","title":"Info_title__y9y1w","links":"Info_links__35PI4","link":"Info_link__AFyI9","logo":"Info_logo__2JQuM"};